export enum ReferrerType {
    RealEstateAgent = 'realEstateAgent',
}
